// extracted by mini-css-extract-plugin
export default {"wrap":"Pp-z","logoContainer":"Qp-z","brandImg":"Rp-z","logoImg":"Sp-z","logoButton":"Tp-z"};